<template>
  <div
    class="app-main-content"
    element-loading-text=""
    element-loading-spinner="none"
    element-loading-background="rgba(170,170,170,0)"
  >
    <customer-tree-grid
      v-show="view==='list'"
      ref="customerTreeGrid"
      style="flex: 1"
      :model-type="1"
      no="1"
      @look="lookHandle"
      @add="addHandle"
    />
    <customer-workspace
      v-show="view==='detail'"
      ref="customerWorkspace"
      :model-type="1"
      no="2"
      @back="backToList"
    />
  </div>
</template>

<script>
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import customerTreeGrid from './components/crm/customerTreeGrid'
import customerWorkspace from './components/crm/customerWorkspace'
import { ErrorTip } from '@/utils/class/ErrorTip'
import { SalesUtil } from '@/class/cargo/model/utils/SalesUtil'

export default {
  name: 'MyGroupCustomer',
  components: { cargoLeftRightResize, customerTreeGrid, customerWorkspace },
  data() {
    return {
      view: 'list'
    }
  },
  created() {
  },
  mounted() {
    SalesUtil.checkCrmExpire(this.$route, this.$router)
  },
  errorCaptured(err) {
    if (err instanceof ErrorTip) {
      this.$message({ message: err.message, type: err.type })
      return false
    }
    return true
  },
  methods: {
    lookHandle(row) {
      this.detailHandle('look', row)
    },
    addHandle(row) {
      this.detailHandle('add', row)
    },
    backToList(isRefresh) {
      this.view = 'list'
      if (isRefresh) {
        this.$refs.customerTreeGrid.toQuery()
      }
    },
    // 进详情公共
    detailHandle(type, row) {
      let rowData = null
      if (this.view === 'detail') {
        rowData = this.$refs.customerWorkspace.rowData
      } else {
        this.view = 'detail'
        rowData = this.$refs.customerTreeGrid.rowData
      }
      this.$refs.customerWorkspace.onShow(type, rowData, row)
    }
  }
}
</script>
